class Store {
  constructor() {
    this.vars = window.statelyVars || {};
    this.init();
  }

  init() {
    this.setOrderTag();
  }

  setOrderTag() {
    const orderTag = sessionStorage.getItem('order_tag');
    const form = document.querySelector('.product-form form');
    if (orderTag && form) {
      // Idempotent: reuse an existing injected input so a re-run can't leave
      // the form with duplicate properties[_order_tag] fields.
      let input = form.querySelector('input[name="properties[_order_tag]"]');
      if (!input) {
        // DOM API, not an HTML string: the tag contains a Convert variation
        // name, and a quote or angle bracket in it would break out of the
        // value="…" attribute if interpolated into markup.
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_order_tag]';
        form.appendChild(input);
      }
      input.value = orderTag;
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  window.store = new Store();
});